import { normalizeCanonicalUrl } from '@/seo/canonical';
import { FormattedDate } from '../FormattedDate';
import { Tag } from '../tag';

type Props = {
  slug: string;
  heroImage?: string | null | undefined;
  heroImageAlt?: string | null | undefined;
  title: string;
  description: string;
  authorImage?: string | null | undefined;
  author: string;
  pubDate: string;
  tags?: ReadonlyArray<string>;
};

export function CardBig({
  slug,
  heroImage,
  heroImageAlt,
  title,
  description,
  authorImage,
  author,
  pubDate,
  tags,
}: Props) {
  return (
    <li className='list-none'>
      <a
        target='_blank'
        href={normalizeCanonicalUrl(`/blog/${slug}`)}
        className='flex flex-col items-start gap-6'
      >
        <img
          alt={heroImageAlt ?? undefined}
          className='w-full rounded-2xl object-cover'
          height={360}
          src={heroImage ?? undefined}
          style={{ aspectRatio: '856 / 334' }}
          width={720}
        />
        <div className='flex max-w-full flex-col gap-2'>
          <h4 className='font-semibold text-black'>{title}</h4>
          <div
            className='truncate text-neutral-500'
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>

        <div className='flex w-full max-w-full flex-col gap-2'>
          <div className='flex w-full flex-wrap items-center justify-between gap-4'>
            <div className='flex items-center gap-3'>
              <div className='flex items-center gap-3'>
                <img
                  alt='Author profile'
                  className='size-11 rounded-full object-cover'
                  height={44}
                  src={authorImage ?? undefined}
                  width={44}
                />
                <p className='text-base leading-none font-normal text-neutral-500'>
                  {author}
                </p>
              </div>
              <p className='text-base leading-none font-medium text-neutral-500'>
                •
              </p>
              <p className='text-base leading-none font-normal text-neutral-500'>
                <FormattedDate date={pubDate} />
              </p>
            </div>
            <div className='flex flex-wrap items-center gap-3'>
              {tags?.slice(0, 3).map((tag, index) => (
                <Tag key={`${tag}-${index.toString()}`} tagName={tag} />
              ))}
            </div>
          </div>
        </div>
      </a>
    </li>
  );
}
